export const goals = [
  'Бокал в лобби', 'Свидание в номере', 'Бассейн или море', 'Поход в ресторан'
];
// '<i class="bokal-ico"></i>Бокал в лобби', '<i class="padushka-ico"></i>Свидание в номере', '<i class="plag-ico"></i>Бассейн или море', '<i class="pribor-ico"></i>Поход в ресторан'
// "<i class='bokal-ico'></i>Бокал в лобби","Свидание в номере","Бассейн или море","Поход в ресторан"